import React from 'react'

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pushDelivery: any
  }
}

export const checkPushInit = (setIsOpen: (value: boolean) => void, setPermission: (value: boolean) => void) =>
  new Promise((resolve, reject) => {
    if (globalThis.window?.Notification?.permission === 'granted') {
      setPermission(true)
      //if window.pushDelivery.messaging is there firebase is initialized
      if (
        globalThis.window.pushDelivery &&
        'messaging' in globalThis.window.pushDelivery &&
        globalThis.window.pushDelivery.getDevice().id
      ) {
        resolve('pushDelivery initialized')
      } else {
        globalThis.window.pushDelivery
          .init()
          .then(() => {
            resolve('pushDelivery initialized')
          })
          .catch((err: Error) => {
            console.log('pushDelivery init failed', err)
            reject(err)
          })
      }
    } else if (Notification?.permission === 'default') {
      //push notification permissions not set, ask for permission
      setIsOpen(true)
      resolve('pushDelivery initialized')
    } else {
      reject('checkPushInit failed')
    }
  })

export const getPermission = (setPermission: (value: boolean) => void) =>
  new Promise((resolve, reject) =>
    Notification?.requestPermission()
      .then(function (permission) {
        if (permission === 'granted') {
          setPermission(true)
          globalThis.window.pushDelivery
            .init()
            .then(() => resolve('pushDelivery initialized'))
            .catch((err: Error) => {
              console.log('pushDelivery init failed', err)
              reject(err)
            })
        } else {
          reject('no permission')
        }
      })
      .catch((err: Error) => {
        console.log('Notification Permission failed', err)
        reject(err)
      }),
  )

export const getPushData = () =>
  new Promise((resolve, reject) => {
    Promise.all([
      globalThis.window.pushDelivery.getSubscribedTags(),
      globalThis.window.pushDelivery.getTags(),
      globalThis.window.pushDelivery.getArchive(),
    ])
      .then(function (values) {
        const subscribedTags = values[0]
        const tagList = values[1]
        const archive = values[2]
        resolve({ subscribedTags, tagList, archive })
      })
      .catch((err: Error) => {
        console.log('getPushData failed', err)
        reject(err)
      })
  })

export const checkPushAsk = (setIsOpen: (value: boolean) => void, setPermission: (value: boolean) => void) => {
  if (globalThis.window?.Notification?.permission === 'granted') {
    setPermission(true)
    return
  }
  const askDenied = localStorage.getItem('askDenied')
  const currentDate = new Date()
  const lastDeniedDate = localStorage.getItem('lastDeniedDate')
  const waitHrsToAskAgain = 672 //wait hours to ask again

  if (askDenied === 'true' && lastDeniedDate !== null) {
    const timeDiff = (currentDate.getTime() - new Date(lastDeniedDate).getTime()) / 1000 / 60 / 60
    if (timeDiff < waitHrsToAskAgain) {
      setIsOpen(false)
    } else {
      checkPushInit(setIsOpen, setPermission)
    }
  }
  let clickCount = Number(localStorage.getItem('clickCount'))
  const clickNumber = 7 //how many clicks until ask
  if (clickCount === null) {
    clickCount = 0
  }
  clickCount++
  localStorage.setItem('clickCount', clickCount.toString())
  if (localStorage.getItem('clickCount') == clickNumber.toString()) {
    checkPushInit(setIsOpen, setPermission)
  }
}
